import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-end gap-x-2 h-full min-h-[40px] px-2" }
const _hoisted_2 = { class: "text-gray-500" }

import { computed } from 'vue';

interface Props {
    label: string | null;
    allocated: number;
    total: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicFormAllocationSummary',
  props: {
    label: {},
    allocated: {},
    total: {}
  },
  setup(__props: any) {

const props = __props;

/* Green when everything is allocated, red when too little or too much is */
const statusClass = computed(() => {
    if (props.total === null) {
        return 'text-gray-800';
    }
    return props.allocated === props.total ? 'text-green-700' : 'text-red-400';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label) + ":", 1),
    _createElementVNode("span", {
      class: _normalizeClass(["font-semibold", statusClass.value])
    }, _toDisplayString(_ctx.$n(_ctx.allocated)) + " / " + _toDisplayString(_ctx.total === null ? '-' : _ctx.$n(_ctx.total)), 3)
  ]))
}
}

})